import { getFileUrl } from '../../../../../Api/Files';
import gravatarUrl from 'gravatar-url';

export function getAvatarUrl (user) {
  let avatarUrl = user.avatar ? getFileUrl(user.avatar) : null;
  if (!avatarUrl) {
	avatarUrl = user.email ? gravatarUrl(user.email, { size: 2048, default: 'mm' }) : '';
  }
  return avatarUrl;
}